const EVENTS = {
  FETCH_VARIANTS_SUCCESS: 'variants/fetch_data_success',
  FETCH_VARIANTS_PROGRESS: 'variants/fetch_data_progress',
  FETCH_VARIANTS_FAILED: 'variants/fetch_data_failed',
  FETCH_VARIANTS_NOT_FOUND: 'variants/fetch_data_not_found',
};

export default EVENTS;
